import { getDevice } from '#pplx/frontend/platform-components/device.js';
export function getSpaQueryClientConfig(bootstrapConfig, userAgent) {
    return {
        buildVersion: import.meta.env.VITE_WEB_RESOURCES_BUILD
            ? bootstrapConfig.webResourcesBuild
            : bootstrapConfig.version,
        // Match PlatformQueryClientProvider when preload creates the singleton first.
        allowPersist: !getDevice(userAgent).isMobile,
    };
}
//# sourceMappingURL=spaQueryClientConfig.js.map